import type { Config } from 'dompurify';

/**
 * Allowed by DOMPurify's defaults, but a template must not use them: each one
 * can submit the viewer's data to an arbitrary external action URL.
 */
const FORBIDDEN_FORM_TAGS = ['form'];

/**
 * Templates render inside a shadow root, where these would project the host's
 * light DOM into the template - never what an author means by them.
 */
const FORBIDDEN_STRUCTURAL_TAGS = ['content', 'decorator', 'element', 'shadow', 'slot'];

/**
 * Outside DOMPurify's default attribute list, but common enough in authored
 * templates that dropping it would be a regression. Browsers imply `noopener`
 * for `target="_blank"`, so it carries no tabnabbing risk.
 */
const ADDITIONAL_ATTRIBUTES = ['target'];

/**
 * Everything not listed here stays at DOMPurify's defaults, which already drop
 * `<script>`, `on*` handlers, `javascript:` URLs and embedded content, and
 * already keep `<style>`, `style` attributes and CSS custom properties.
 */
export const SANITIZATION_CONFIG: Config = {
  ADD_ATTR: ADDITIONAL_ATTRIBUTES,
  FORBID_TAGS: [...FORBIDDEN_FORM_TAGS, ...FORBIDDEN_STRUCTURAL_TAGS],
  FORCE_BODY: true,
};
